import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        meta:
        {
            title: '',
            component: 'app-page-home',
            dataSrc: '/home?instagram&medias=&projects=&article=&team=&agency'
        }
    },
    {
        path: '/article/:postId',
        name: 'article',
        meta:
        {
            isModal: true
        }
    },
    {
        path: '/medias/:postId',
        name: 'medias',
        meta:
        {
            isModal: true
        }
    },
    {
        path: '/agency/:postId',
        name: 'agency',
        meta:
        {
            isModal: true
        }
    },
    {
        path: '/projects/:postId',
        name: 'project',
        meta:
        {
            component: 'app-page-project',
            dataSrc: '/projects/'
        }
    },
    {
        path: '/clients',
        name: 'clients',
        meta:
        {
            component: 'app-page-clients',
            dataSrc: '/clients/'
        }
    },
    {
        path: '/team',
        name: 'team',
        meta:
        {
            component: 'app-page-team',
            dataSrc: '/team/'
        }
    },
    {
        path: '/contact',
        name: 'contact',
        meta:
        {
            component: 'app-page-contact',
            dataSrc: '/contact/'
        }
    },
    {
        path: '/map',
        name: 'map',
        meta:
        {
            component: 'app-page-map',
            dataSrc: '/map/'
        }
    },
    {
        path: '/shop',
        name: 'shop',
        meta:
        {
            component: 'app-page-shop',
            dataSrc: '/products/'
        }
    },
    {
        path: '/shop/:postId',
        name: 'product',
        meta:
        {
            component: 'app-page-product',
            dataSrc: '/products/'
        }
    },
    {
        path: '/search',
        name: 'search',
        meta:
        {
            component: 'app-page-search',
            dataSrc: '/search/'
        }
    },
    {
        path: '/encyclopedia',
        name: 'encyclopedia-detail',
        meta:
        {
            component: 'app-page-encyclopedia-coming-soon',
            dataSrc: '/encyclopedia/'
        }
    },
    {
        path: '/encyclopedia/:postId',
        name: 'encyclopedia-detail',
        meta:
        {
            component: 'app-page-encyclopedia-detail',
            dataSrc: '/encyclopedia/'
        }
    },
    {
        path: '/my-selection',
        name: 'my-selection',
        meta:
        {
            component: 'app-page-selection',
            dataSrc: '/selection/'
        }
    },
    {
        path: '/philosophy',
        name: 'philosophy',
        meta:
        {
            component: 'app-page-cms',
            dataSrc: '/philosophy/'
        }
    },
    {
        path: '/legals',
        name: 'legals',
        meta:
        {
            component: 'app-page-cms',
            dataSrc: '/legals/'
        }
    },
    {
        path: '*',
        name: '404',
        meta:
        {
            component: 'app-page-404',
            dataSrc: '/404/'
        }
    }
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router



// WEBPACK FOOTER //
// ./src/scripts/router/index.js